import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { themes } from '../theme.ts';

const MySwal = withReactContent(Swal);

export const showConfirmation = (
  title: string,
  text: string,
  confirmButtonText: string,
  cancelButtonText: string,
  onConfirm: () => void,
  onCancel?: () => void
) => {
  const themeName = localStorage.getItem('themeName') as keyof typeof themes || 'light';
  const currentTheme = themes[themeName].colors;

  let confirmButtonColor = currentTheme.primary;
  if (confirmButtonText === 'Delete' || confirmButtonText === 'Disable') {
    confirmButtonColor = currentTheme.error;
  } else if (confirmButtonText === 'Enable') {
    confirmButtonColor = currentTheme.success;
  }

  MySwal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor,
    cancelButtonColor: currentTheme.neutral,
    confirmButtonText,
    cancelButtonText,
    background: currentTheme.card,
    color: currentTheme.text,
    customClass: {
      popup: 'rounded-lg',
      title: 'text-lg font-semibold',
      confirmButton: 'px-4 py-2 rounded-md text-white',
      cancelButton: 'px-4 py-2 rounded-md text-white',
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      if (onCancel) {
        onCancel();
      }
    }
  });
};
